module.exports = __webpack_public_path__ + "Vikatan_google_news_new-34fef0fd549de338ba04.svg";